import React, { Fragment, useState, useEffect } from "react";
import {
  Button,
  Modal,
} from "react-bootstrap";

import axios from "axios";
import { Progress } from "reactstrap";
import { getInstance } from '../config/token';
import PhoneInput from 'react-phone-number-input'
import { getCountryCallingCode } from 'react-phone-number-input/input'
import { fn } from "jquery";
import Spinner from 'react-bootstrap/Spinner'
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const prefix = process.env.REACT_APP_API_URL

const AddContactPopup = (props) => {
  const [fileName, setFileName] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filePath, setFilePath] = useState([]);
  const [country, setCountry] = useState("US")
  const [countryCode, setCountryCode] = useState("1")
  const [fName, setFName] = useState(null)
  const [lName, setLName] = useState(null)
  const [address1, setAddress1] = useState(null)
  const [address2, setAddress2] = useState(null)
  const [city, setCity] = useState(null)
  const [state, setState] = useState(null)
  const [zip, setZip] = useState(null)
  const [phone, setPhone] = useState("")
  const [newEvent, setNewEvent] = useState(false);
  const [loadingDetail, setLoadingDetail] = useState(false);
  const [file, setFile] = useState("");
  const [loaded, setLoader] = useState(0);
  const [cameraModal, setCameraModal] = useState(false);
  const [profileUrl, setProfileUrl] = useState("");
  const [deletePopup, setDeletePopup] = useState(false);


  useEffect(() => {
    getContactDetail()

  }, []);

  const getContactDetail = () => {
    if (props.contactId) {
      setLoadingDetail(true)
      let config = getInstance('GET', `/api/get_contact_detail/` + props.contactId);
      axios(config)
        .then((res) => {
          console.log(res.data)
          let data = res.data && res.data[0] ? res.data[0] : ""
          console.log(data)
          if (data) {
            setFName(data.first_name)
            setLName(data.last_name)
            setAddress1(data.address_line_1)
            setAddress2(data.address_line_2)
            setCity(data.city)
            setState(data.state)
            setZip(data.zip)
            setProfileUrl(data.profile)
            setPhone(data.phone)
            setCountryCode(data.calling_code)
            setCountry(data.country_code)
          }

          setLoadingDetail(false)
        })
        .catch((err) => {
          setLoadingDetail(false)
        })
    }

  }

  const deleteContact = () => {
    let requestObj = {
      contactId: props.contactId
    }
    setLoading(true)
    let config = getInstance('POST', `/api/update_contact`, requestObj);
    axios(config)
      // .post(prefix + "/api/create_ticket", requestObj)
      .then((res) => {
        setDeletePopup(false)
        props.closeContactPopup();
        setFileName([]);
        setPhone("");
        setFName("");

        setLName("");
        setAddress1("");
        setAddress2("");
        setCity("");
        setState("");
        setZip("");
        setFile("");
        if (props.type == 'contact') {
          props.getContactList()
        }
        if (props.type == 'sms-detail') {
          props.reloadSmsDetail()
        }
        if (props.type == 'customer') {
          props.getCustomerList()
        }
        setFilePath([])
        // setSelected([])
        setLoading(false)

        let deleteMessage = "Contact deleted successfully!"
        if(props.type == 'customer') {
          deleteMessage = "Customer deleted successfully!"
        }
        toast.success(deleteMessage, {
          position: "top-right",
        });
      })
      .catch((err) => {
        setLoading(false)
        let msg = "Something went wrong!"
        // setLoading(false)
        if (err.response && err.response.data && err.response.data.message) {
          msg = err.response.data.message
        }
        toast.error(msg, {
          position: "top-right",
        });
      });

  }


  const saveContact = () => {
    // setErrMsg("")
    let errFlag = false;
    if (phone == "") {
      errFlag = true;
      toast.error("phone is required.", {
        position: "top-right",
      });
      // setErrMsg("Title is required.");
    } else if (phone.length < 4) {
      errFlag = true;
      toast.error("Phone can not be less than 4 digit.", {
        position: "top-right",
      });
      // setErrMsg("Title can not be more than 255 characters.");
    } else if (!fName) {
      errFlag = true;
     toast.error("First Name is required.", {
        position: "top-right",
      });
      // setErrMsg("Title can not be more than 255 characters.");
    } else if (!lName) {
      errFlag = true;
     toast.error("Last Name is required.", {
        position: "top-right",
      });
      // setErrMsg("Title can not be more than 255 characters.");
    }

    if (!errFlag) {
      let requestObj = {
        phone: phone,
        profile: filePath,
        code: countryCode,
        country: country,
        first_name: fName,
        last_name: lName,
        address_line_1: address1,
        address_line_2: address2,
        city: city,
        state: state,
        zip: zip,
        type : props.userType
      };

      if (props.contactId) {
        requestObj.contactId = props.contactId
      }

      setLoading(true)
      let config = getInstance('POST', `/api/save_contact`, requestObj);
      axios(config)
        // .post(prefix + "/api/create_ticket", requestObj)
        .then((res) => {
          props.closeContactPopup();
          setFileName([]);
          setPhone("");
          setFName("");

          setLName("");
          setAddress1("");
          setAddress2("");
          setCity("");
          setState("");
          setZip("");
          setFile("");
          if (props.type == 'contact') {
            props.getContactList()
          }
          if (props.type == 'sms-detail') {
            props.reloadSmsDetail()
          }
          if (props.type == 'customer') {
            props.getCustomerList()
          }
          setFilePath([])
          // setSelected([])
          setLoading(false)

          let successMessage = "Contact saved successfully!"
          if(props.type == 'customer') {
            successMessage = "Customer saved successfully!"
          }
          toast.success(successMessage, {
            position: "top-right",
          });
        })
        .catch((err) => {
          setLoading(false)
          let msg = "Something went wrong!"
          // setLoading(false)
          if (err.response && err.response.data && err.response.data.message) {
            msg = err.response.data.message
          }
          toast.error(msg, {
            position: "top-right",
          });
        });
    }
    // else {
    //   toast.error(errMsg, {
    //     position: "top-right",
    //   });
    // }
  };

  const maxSelectFile = (event) => {
    let files = event.target.files // create file object
    if (files.length > 1) {
      //  const msg = 'Only 3 images can be uploaded at a time'
      event.target.value = null // discard selected file
      toast.error("Only 1 files can be uploaded at a time.", {
        position: "top-right",
      });
      return false;

    }
    return true;

  }

  const checkFileSize = (event) => {
    let files = event.target.files
    let size = 5000000
    let err = "";
    for (var x = 0; x < files.length; x++) {
      if (files[x].size > size) {
        err += files[x].type + ' is too large, please pick a smaller file\n';
      }
    };
    if (err !== '') {
      event.target.value = null
      toast.error(err, {
        position: "top-right",
      });
      return false
    }

    return true;

  }

  const onFileChange = (e) => {
    // this.setState({ file: e.target.files[0] },() => {
    var mulFiles = e.target.files
    if (maxSelectFile(e) && checkFileSize(e)) {
      setLoading(true)
      setFile(mulFiles);
      const data = new FormData();
      for (var x = 0; x < mulFiles.length; x++) {
        data.append('file', mulFiles[x])
      }
      // data.append("file", e.target.files[0]);
      let config = getInstance('POST', `/api/upload`, data);
      // axios(config,
      //   onUploadProgress: (ProgressEvent) => {
      //     console.log("ProgressEvent", ProgressEvent)
      //     setLoader((ProgressEvent.loaded / ProgressEvent.total) * 100);
      //   },
      // )
      axios.post(config.url, config.data, {
        headers: config.headers,
        onUploadProgress: (ProgressEvent) => {
          setLoader((ProgressEvent.loaded / ProgressEvent.total) * 100);
        },
      })

        .then((res) => {
          // then print response status
          setLoader(0);
          setCameraModal(false);
          let filePathArray = filePath
          let fName = fileName
          for (let i = 0; i < res.data.length; i++) {
            // setFileName(res.data[i] && res.data[i].filename ? res.data[isNaN].filename : "");
            let filepath = prefix + '/' + res.data[i].path
            setProfileUrl(filepath)
            filePathArray.push(filepath)
            // setFilePath(filepath)
            fName.push(res.data[i].filename)
          }
          setFilePath(filePathArray)
          setFileName(fName)
          setLoading(false)
        })
        .catch((err) => {
          setLoading(false)
          console.log(err)
        });
    }
  };

  const setPhoneNumber = (phone) => {
    if (phone != undefined) {
      setPhone(phone)
    }
  }

  const setCountryData = (country) => {
    if (country != undefined) {
      setCountry(country)
      setCountryCode(getCountryCallingCode(country))
    }
  }

  return (
    <Fragment>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Modal enforceFocus={false} className="modal fade" show={props.contactPopupShow}>
        <div className="">
          <div className="modal-header">
          <h5 className="modal-title">{props.userType == 3 ? "Save Customer" : "Save Contacts"}</h5>
            <Button
              variant=""
              type="button"
              className="close"
              data-dismiss="modal"
              onClick={() => props.closeContactPopup()}
            >
              <span>×</span>
            </Button>
          </div>
          <div className="modal-body">
            <form
              className="comment-form"
              onSubmit={(e) => {
                e.preventDefault();
                // setNewEvent(false);
              }}
            >
              <div>
                {loadingDetail ?
                  <div
                    style={{
                      textAlign: "center",
                      width: "100%",
                      position: "absolute",
                      marginBottom: "10px",
                    }}
                  >
                    <Spinner animation="border" role="status">
                      <span className="visually-hidden"></span>
                    </Spinner>
                  </div>
                  :
                  <React.Fragment>
                    <div className="form-group">
                      <div className="form-group">
                        <label className="text-black font-w500">First Name</label>
                        <input
                          type="text"
                          name="fname"
                          className="form-control form-border-color"
                          maxLength={100}
                          required
                          value={fName}
                          onChange={(e) => setFName(e.target.value)}
                        />
                      </div>
                      <div className="form-group">
                        <label className="text-black font-w500">Last Name</label>
                        <input
                          type="text"
                          name="lname"
                          className="form-control form-border-color"
                          maxLength={100}
                          required
                          value={lName}
                          onChange={(e) => setLName(e.target.value)}
                        />
                      </div>
                      <div className="form-group">
                        <label className="text-black font-w500"
                          style={{ display: "block" }}>Phone Number</label>
                        <PhoneInput
                          // international
                          defaultCountry="US"
                          placeholder="Enter phone number"
                          value={phone}
                          onChange={(e) => setPhoneNumber(e)}
                          disabled={props.contactId ? true : false}
                          onCountryChange={(e) => setCountryData(e)} />
                      </div>

                      <div className="form-group">
                        <label className="text-black font-w500">Address 1</label>
                        <input
                          type="text"
                          name="address1"
                          className="form-control form-border-color"
                          maxLength={255}
                          required
                          value={address1}
                          onChange={(e) => setAddress1(e.target.value)}
                        />
                      </div>
                      <div className="form-group">
                        <label className="text-black font-w500">Address 2</label>
                        <input
                          type="text"
                          name="address2"
                          className="form-control form-border-color"
                          maxLength={255}
                          required
                          value={address2}
                          onChange={(e) => setAddress2(e.target.value)}
                        />
                      </div>
                      <div className="form-group">
                        <label className="text-black font-w500">City</label>
                        <input
                          type="text"
                          name="city"
                          className="form-control form-border-color"
                          maxLength={255}
                          required
                          value={city}
                          onChange={(e) => setCity(e.target.value)}
                        />
                      </div>
                      <div className="form-group">
                        <label className="text-black font-w500">State</label>
                        <input
                          type="text"
                          name="state"
                          className="form-control form-border-color"
                          maxLength={255}
                          required
                          value={state}
                          onChange={(e) => setState(e.target.value)}
                        />
                      </div>
                      <div className="form-group">
                        <label className="text-black font-w500">Zip</label>
                        <input
                          type="text"
                          name="zip"
                          className="form-control form-border-color"
                          maxLength={255}
                          required
                          value={zip}
                          onChange={(e) => setZip(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <button
                        // to="/app-profile"
                        disabled={loading}
                        className="btn btn-primary light px-3 "
                        data-toggle="modal"
                        data-target="#cameraModal"
                        type="button"
                        onClick={() => setCameraModal(true)}
                      >
                        <i className="fa fa-camera m-0" />
                        {" Upload File "}
                      </button>
                      {fileName.map(function (name, j) {
                        return (
                          <div>
                            {name}
                            <br />
                          </div>
                        );
                      })}
                      <img src={profileUrl} className="mr-3 rounded" width={75} />
                      {/* {fileName} */}
                    </div>
                    {/* Modal */}
                    <Modal
                      show={cameraModal}
                      // onHide={() => this.setState({ cameraModal: false })}
                      className="modal fade"
                      id="cameraModal"
                    >
                      <div className="">
                        <div className="modal-header">
                          <h5 className="modal-title">Upload Profile Picture</h5>
                          <button
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            onClick={() => setCameraModal(false)}
                          >
                            <span>×</span>
                          </button>
                        </div>
                        <div className="modal-body">
                          <div className="input-group mb-3">
                            <div className="input-group-prepend">
                              <span className="input-group-text">Upload</span>
                            </div>
                            <div className="custom-file ">
                              <input
                                type="file"
                                name="file"
                                multiple
                                className="custom-file-input"
                                accept="image/png, image/gif, image/jpeg"
                                onChange={(e) => onFileChange(e)}
                              />
                              <label className="custom-file-label form-border-color">
                                Choose file
                              </label>
                            </div>
                          </div>
                          <div class="form-group">
                            <Progress max="100" color="success" value={loaded}>
                              {Math.round(loaded, 2)}%
                            </Progress>
                          </div>
                        </div>
                      </div>
                    </Modal>
                    <Modal
                      show={deletePopup}
                      // onHide={() => this.setState({ cameraModal: false })}
                      className="modal fade"
                      id="cameraModal"
                    >
                      <div className="">
                        <div className="modal-header">
                        <h5 className="modal-title">{props.userType == 3 ? "Delete Customer" : "Delete Contact"}</h5>
                          <button
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            onClick={() => deletePopup(false)}
                          >
                            <span>×</span>
                          </button>
                        </div>

                        <div className="modal-body">
                          <form
                            className="comment-form"
                            onSubmit={(e) => {
                              e.preventDefault();
                              // setNewEvent(false);
                            }}
                          >
                            <div>
                              <div className="form-group">
                                <div className="form-group">
                                <strong style={{ color: "black" }}>{props.userType == 3 ? "Are you sure you want to delete this customer." : "Are you sure you want to delete this contact."}</strong>
                                </div>
                              </div>
                              <div className="form-group" style={{ textAlign: "center" }}>

                                <input
                                  type="submit"
                                  value="No"
                                  className="btn btn-primary"
                                  onClick={() => setDeletePopup(false)}

                                />
                                <input
                                  disabled={loading}
                                  type="submit"
                                  value="Delete"
                                  className="btn btn-danger"
                                  onClick={() => deleteContact()}
                                  style={{ marginLeft: "10px" }}
                                />
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </Modal>
                    <div className="form-group" style={{ textAlign: "center" }}>
                      <input
                        disabled={loading}
                        type="submit"
                        value={props.userType == 3 ? "Save Customer" : "Save Contact"}
                        className="btn btn-primary"
                        onClick={() => saveContact()}
                      />
                      {props.contactId ?
                        <input
                          // disabled={loading}
                          type="submit"
                          value={props.userType == 3 ? "Delete Customer" : "Delete Contact"}
                          className="btn btn-danger"
                          onClick={() => setDeletePopup(true)}
                          style={{ marginLeft: "10px" }}
                        /> : ""}
                    </div>
                  </React.Fragment>
                }
              </div>
            </form>
          </div>
        </div>
      </Modal>
    </Fragment>
  )
};

export default AddContactPopup;
